import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import toast from "react-hot-toast";

import { IConfigurationEquipmentServicesListResponse } from "@/api_framework/api_modals/Configuration";
import { setEquipmentService } from "@/app_redux/reducers/slices/auth/configuration_slice";
import { useCallback } from "react";
import { useCurlLogger } from "../../useCurlLogger";
import AxiosCurlirize from "axios-curlirize";

AxiosCurlirize(axios, () => {});
export const useConfigurationEquipmentServiceListAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      await axios
        .get(CONFIGURATION_APIS?.EQUIPMENT_SERVICE_LIST?.baseURL ?? "", {
          params: {},
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IConfigurationEquipmentServicesListResponse>) => {
          if (res.data.status === true) {
            dispatch(
              setEquipmentService({
                data: res.data.data,
              }),
            );
          } else {
            toast.error("Error while fetching Equipment Services List");
          }
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config["curlCommand"]);
        });
    } catch (e) {
      if (axios.isAxiosError(e)) {
        if (e.code === "ERR_BAD_REQUEST") {
          toast.error("Error at server while fetching user role.");
        }
        if (e.response?.status === 400) {
          toast.error(e.message);
        }
        if (e.response?.status === 500) {
          toast.error("Internal Server Error, Contact Tech Team.");
        }
      } else {
        toast.error("Server Error: " + e.message);
      }

      throw e;
    }
  }, [dispatch, configuration]);

  return execute;
};
